<template>
  <div id="app">

    <navigation-bar v-if="user" />
    <router-view/>
  </div>
</template>

<script>
import NavigationBar from './components/NaviagtionBar';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export default {
  components: {
    NavigationBar
  },
  data() {
    return {
      user: null
    };
  },
  created() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.user = user;
    });
  }
};
</script>
